import { render, staticRenderFns } from "./RadioBlock.vue?vue&type=template&id=a9c00a12&"
import script from "./RadioBlock.vue?vue&type=script&lang=js&"
export * from "./RadioBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports